<div class="row align-items-center flex-nowrap h-100 gx-2">
  <div class="col-auto mw-0 flex-shrink-1">
    <mwe-header-logo />
  </div>
  @if (isLoggedIn) {
    <div class="col">
      <div role="navigation" class="row g-3 align-items-center justify-content-end">
        <div class="col-auto d-none d-lg-block">
          <mwe-button
            size="md"
            category="tertiary"
            color="white"
            prependIconClass="fas fa-box"
            labelKey="global.navbar.products"
            [active]="isProductPath"
            [route]="productsRoute"
            buttonId="mwe-products-header-link"
          />
        </div>
        @if (config.goodies.isRouteEnabled) {
          <div class="col-auto d-none d-lg-block">
            <mwe-button
              size="md"
              category="tertiary"
              color="white"
              prependIconClass="fas fa-gift"
              buttonId="navbar-header-goodies-link"
              labelKey="global.navbar.goodies"
              [route]="goodieRoute"
              (clicked)="resetProductState()"
              [active]="isGoodiePath"
            />
          </div>
        }
        <div #profileDropdown="ngbDropdown" class="col-auto d-none d-lg-block" ngbDropdown placement="bottom-right top-right">
          <mwe-button
            size="md"
            category="tertiary"
            color="white"
            prependIconClass="fas {{ config.profile.menuIconClass }}"
            appendIconClass="fas fa-chevron-down transition-all {{ profileDropdown.isOpen() ? 'rotate-180' : '' }}"
            buttonId="navbar-header-profile-link"
            labelKey="global.navbar.profile"
            ngbDropdownToggle
            [active]="profileDropdown.isOpen()"
          />
          <div class="dropdown-menu dropdown-menu-right font-size-16" style="min-width: 380px" ngbDropdownMenu>
            <div class="card-basic text-start" data-test="profile-dropdown-menu-container">
              <div class="card-basic-body card-basic-segment p-3">
                <div class="row g-2 align-items-center flex-nowrap">
                  <div class="col-auto">
                    <div
                      class="bg-primary text-white rounded-pill d-inline-flex align-items-center justify-content-center"
                      style="width: 2rem; height: 2rem"
                    >
                      <i [ngClass]="config.profile.menuIconClass" class="fas"></i>
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-secondary text-break fw-bold mb-1">{{ userName }}</div>
                    <div class="text-body mb-0">{{ emailAddress }}</div>
                  </div>
                  <div class="col-auto">
                    <mwe-badge [text]="config.profile.menuTagNameLabel" type="info" emphasis="bold" size="md" />
                  </div>
                </div>
              </div>
              <div class="card-basic-body card-basic-segment p-3">
                <div class="mb-3">
                  <a
                    (click)="profileDropdown.close()"
                    [routerLink]="profileRoute"
                    class="text-secondary link-active-opacity text-focus-ring"
                    data-test="profile-dropdown-menu-profile-link"
                    routerLinkActive="active"
                    translate="global.navbar.profileSubMenu.profileLinkText"
                  ></a>
                </div>
                <div>
                  <a
                    (click)="profileDropdown.close(); switchPortal()"
                    (keydown.enter)="profileDropdown.close(); switchPortal()"
                    [translate]="config.profile.portalSwitchRouteLabel"
                    class="text-secondary link-active-opacity text-focus-ring pointer d-block"
                    data-test="profile-dropdown-menu-business-link"
                    routerLinkActive="active"
                    tabindex="0"
                  ></a>
                </div>
              </div>
              <div class="card-basic-body card-basic-segment p-3">
                <div>
                  <a
                    (click)="profileDropdown.close(); logout()"
                    (keyup.enter)="profileDropdown.close(); logout()"
                    class="text-secondary pointer link-active-opacity text-focus-ring"
                    data-test="profile-dropdown-menu-logout-link"
                    tabindex="0"
                  >
                    <i class="fas fa-sign-out"></i>
                    {{ 'global.navbar.profileSubMenu.logoutLinkText' | translate }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (messagesEnabled()) {
          <div class="col-auto nav-item-popover">
            <button
              (click)="openMessagesOverlay()"
              [ngClass]="{ heartbeat: messagesStore.unreadMessageCount() && messagesPristine() }"
              class="btn btn-sm btn-ghost-outline px-12px font-size-16"
              data-test="navbar-header-messages-toggle"
              style="min-width: 2.875rem"
              title="{{ 'mnr.title' | translate }}"
            >
              <i aria-hidden="true" class="fas fa-envelope"></i>
              @if (messagesStore.unreadMessageCount()) {
                <span class="ml-1">{{ messagesStore.unreadMessageCount() }}</span>
              }
            </button>
            <ng-template #messagesComponent />
          </div>
        }
      </div>
    </div>
  }
</div>
